import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Dropdown, Menu, Space } from 'antd'
import { Link, NavLink, useRouteMatch } from 'react-router-dom'
import { DownOutlined, ArrowLeftOutlined, MenuOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import useCoursePrivilege from '../../hooks/useCourseprivilege'

const CourseMenu = ({ url, privilege }) => (
  <Menu>
    <Menu.Item>
      <Link to={`${url}/modules`}>Modules</Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={`${url}/lectures`}>Lectures</Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={`${url}/assignments`}>Assignments</Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={`${url}/exams`}>Exams</Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={`${url}/announcments`}>Announcements</Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={`${url}/gradebook`}>Gradebook</Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={`${url}/discussions`}>Discussions</Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={`${url}/live`}>Live Sessions</Link>
    </Menu.Item>
    {privilege !== 'student' && (
      <Menu.Item>
        <Link to={`${url}/particpants`}>Participants</Link>
      </Menu.Item>
    )}
    {privilege !== 'student' && (
      <Menu.Item>
        <Link to={`${url}/settings`}>Settings</Link>
      </Menu.Item>
    )}
  </Menu>
)

const CourseNavigation = ({ isMobile }) => {
  const { params, url } = useRouteMatch('/app/course/:id')
  const history = useHistory()

  const course = useSelector((state) =>
    state.courses.data.find((c) => c.id === params.id)
  )

  const { privilege } = useCoursePrivilege(params.id)

  const popHistory = () => history.goBack()

  if (!course) return null

  if (isMobile) {
    return (
      <Space size="small">
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ color: '#fff', fontSize: 18 }} />}
          onClick={popHistory}
          style={{ minWidth: 44, minHeight: 44, padding: 0 }}
        />
        <Dropdown
          overlay={<CourseMenu url={url} privilege={privilege} />}
          placement="bottomLeft"
          trigger={['click']}
        >
          <Button
            type="text"
            style={{
              color: '#fff',
              fontWeight: 600,
              maxWidth: 160,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              padding: '0 8px',
              minHeight: 44
            }}
          >
            {course.name} <DownOutlined />
          </Button>
        </Dropdown>
      </Space>
    )
  }

  return (
    <>
      <Space>
        <Button
          shape="circle"
          type="secondary"
          onClick={popHistory}
          icon={<ArrowLeftOutlined />}
        />
        <Dropdown
          overlay={<CourseMenu url={url} privilege={privilege} />}
          placement="bottomCenter"
        >
          <Button
            shape="round"
            style={{ backgroundColor: course.backgroundColor }}
          >
            <span style={{ fontWeight: 600, color: 'white' }}>
              {course.name}
            </span>{' '}
            <DownOutlined style={{ color: 'white' }} />
          </Button>
        </Dropdown>
      </Space>
      <NavLink to={`${url}/modules`}>
        <Button type="text">Modules</Button>
      </NavLink>
      <NavLink to={`${url}/lectures`}>
        <Button type="text">Lectures</Button>
      </NavLink>
      <NavLink to={`${url}/assignments`}>
        <Button type="text">Assignments</Button>
      </NavLink>
      <NavLink to={`${url}/exams`}>
        <Button type="text">Exams</Button>
      </NavLink>
    </>
  )
}

export default CourseNavigation
